import Alert from 'components/Alert'
import Button from 'components/Button/Button'
import Divider from 'components/Divider'
import { Input } from 'components/Input'
import Spinner from 'components/Spinner'
import moment from 'moment'
import toast from 'cogo-toast'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { useAppDispatch, useAppState } from 'store'
import { transactionActions } from 'store/slices/transactions/transactions.slice'
import { PENNIES } from 'utils/rate'
import { TransactionDetailsModalProps } from './TransactionDetailsModal.props'
import {
  ModalTemplateSubTitle,
  TransactionLabel,
  TransactionModalContainer,
  TransactionModalLoadingContainer,
  TransactionModalSubContainer,
  TransactionText,
} from './TransactionDetailsModal.styled'
import { Col, Row } from 'react-grid-system'

const TransactionDetailsModal: React.FC<TransactionDetailsModalProps> = ({
  locationId,
  transaction,
  clientId,
  onClose,
}) => {
  const {
    paid,
    appointment,
    invoice_type,
    description,
    subtotal,
    amount,
    created_at,
    tax,
    id
  } = transaction
  const history = useHistory()
  const dispatch = useAppDispatch()
  const [currentSubtotal, setCurrentSubtotal] = useState<number>(subtotal / PENNIES)
  const [currentTax, setCurrentTax] = useState<number>(tax / PENNIES)
  const { createPaymentTransactionLoading } = useAppState(state => state.transaction)

  const handleAppointment = () => {
    dispatch(transactionActions.setCurrentTransaction(transaction))
    history.replace(`/locations/${locationId}`)
  }

  const calculateTotal = (): number => {
    let total = currentSubtotal || 0
    if (currentTax) {
      total = total + currentTax
    }
    return total
  }

  const getPriceInPennies = (price: any) => price !== 0 ? price / 100 : price;

  const handlePayment = async () => {
    const params = {
      locationId,
      clientId,
      amount,
      subtotal,
      tax,
      invoice_ids: [id],
      description,
      payment_method: {
        payment_method_id: null,
        payment_token_data: null,
        payment_type: 'credit_card'
      }
    }

    await dispatch(
      transactionActions.createPaymentTransaction(params)
    ).then(async (data: any) => {
      if (data && data.payload && !data.payload.error) {
        onClose();
        toast.success(`Payment successfully charged to card`, {
          position: 'top-right',
        })
      }
    })
  }

  const deleteTransaction = async () => {
    await dispatch(
      transactionActions.deleteTransaction({ locationId, id })
    ).then((data: any) => {
      if (data && data.payload && !data.payload.error) {
        toast.success(`Transaction deleted successfully`, {
          position: 'top-right',
        })
        onClose();
      }
    })
  }

  return (
    <>{createPaymentTransactionLoading === 'loading' ? (
      <TransactionModalLoadingContainer>
        <Spinner />
      </TransactionModalLoadingContainer>
    ) : (
      <TransactionModalContainer>
        {paid === 'paid' && <Alert msg={paid} type={'success'} />}
        {paid === 'unpaid' && <Alert msg={paid} type={'danger'} />}
        <TransactionModalSubContainer>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
              <Row>
                <Col xs={12} sm={12} md={5} lg={5}>
                  <TransactionLabel>Date:</TransactionLabel>
                </Col>
                <Col xs={12} sm={12} md={7} lg={7}>
                  <TransactionText>
                    {moment(created_at).format('MMMM DD, YYYY')}
                  </TransactionText>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <TransactionLabel>Subtotal:</TransactionLabel>
                </Col>
                <Col xs={12} sm={12} md={9} lg={9}>
                  {paid === 'paid' && (
                    <TransactionText>$ {getPriceInPennies(subtotal).toFixed(2)}</TransactionText>
                  )}
                  {paid === 'unpaid' && (
                    <Input
                      currencyMask
                      style={{ width: '70%', marginBottom: 10 }}
                      value={currentSubtotal.toFixed(2)}
                      onTextChange={newSubtotal =>
                        setCurrentSubtotal(parseFloat(newSubtotal))
                      }
                      disabled
                      noMargin
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
              <Row>
                <Col xs={12} sm={12} md={5} lg={5}>
                  <TransactionLabel>Transaction Type:</TransactionLabel>
                </Col>
                <Col xs={12} sm={12} md={7} lg={7}>
                  <TransactionText> {invoice_type} </TransactionText>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <Row>
                <Col xs={12} sm={12} md={3} lg={3}><TransactionLabel>Tax:</TransactionLabel></Col>
                <Col xs={12} sm={12} md={9} lg={9}>
                  {paid === 'paid' && (
                    <TransactionText>$ {getPriceInPennies(tax).toFixed(2)}</TransactionText>
                  )}
                  {paid === 'unpaid' && (
                    <Input
                      currencyMask
                      style={{ width: '70%', marginBottom: 10 }}
                      min={0}
                      max={PENNIES}
                      value={currentTax.toFixed(2)}
                      onTextChange={newTax => setCurrentTax(parseFloat(newTax))}
                      disabled
                      noMargin
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6}><Row>
              <Col xs={12} sm={12} md={5} lg={5}>
                <TransactionLabel>Description:</TransactionLabel>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7}>
                <TransactionText> {description} </TransactionText>
              </Col>
            </Row></Col>
            <Col xs={12} sm={12} md={6} lg={6}><Row>
              <Col xs={12} sm={12} md={3} lg={3}><TransactionLabel>Total:</TransactionLabel></Col>
              <Col xs={12} sm={12} md={9} lg={9}>
                {paid === 'paid' && (
                  <TransactionText> $ {getPriceInPennies(amount).toFixed(2)} </TransactionText>
                )}
                {paid === 'unpaid' && (
                  <Input
                    currencyMask
                    style={{ width: '70%' }}
                    value={calculateTotal()}
                    disabled
                    noMargin
                  />
                )}</Col>
            </Row></Col>
          </Row>
        </TransactionModalSubContainer>
        {paid === 'unpaid' &&
          <>
            <Divider />
            <ModalTemplateSubTitle>Transaction Actions</ModalTemplateSubTitle>
            <Row>
              <Col xs={12} sm={12} md={5} lg={5}>
                <Button
                  style={{ border: '2px solid' }}
                  variant={'secondary'}
                  text={'Delete Transaction'}
                  size={'medium'}
                  onClick={deleteTransaction}
                />
              </Col>
              <Col xs={12} sm={12} md={7} lg={7}>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={6}><Button
                    style={{ border: '2px solid' }}
                    variant={'primary'}
                    text={'Process Card Payment'}
                    size={'medium'}
                    onClick={handlePayment}
                    disabled={amount === 0}
                  /></Col>
                  <Col xs={12} sm={12} md={6} lg={6}>
                    <Button
                      style={{ border: '2px solid' }}
                      variant={'primary'}
                      text={'Cancel'}
                      size={'medium'}
                      onClick={onClose}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </>}
      </TransactionModalContainer>)
    }</>
  )
}

export default TransactionDetailsModal
